import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["upload", "bypass", "submit", "uploading"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasBypassTarget) return

    const hasUploadedImages = this.uploadTargets.some((upload) => {
      return upload.classList.contains("existing-image")
    })

    const allUploadedImages = this.uploadTargets.every((upload) => {
      return upload.classList.contains("existing-image")
    })

    if (hasUploadedImages) {
      this.bypassTarget.checked = false
    }

    this.bypassTarget.disabled = hasUploadedImages

    if (this.bypassTarget.checked) {
      // bypassed
      this.submitTarget.disabled = false
    } else if (allUploadedImages) {
      // all uploaded
      this.submitTarget.disabled = false
    } else {
      // not bypassed, nor fully uploaded
      this.submitTarget.disabled = true
    }
  }

  submitStart() {
    this.submitTargetValueBefore = this.submitTarget.value
    this.submitTarget.value = "Please wait..."
    this.startUploadingMesssages()
  }

  submitEnd() {
    this.submitTarget.value = this.submitTargetValueBefore
    this.stopUploadingMessages()
  }

  startUploadingMesssages() {
    this.uploadingTimeout = setTimeout(this.updateUploadingMessage.bind(this), 5000)
  }

  updateUploadingMessage() {
    // display the warning
    this.uploadingTarget.classList.remove("hide")

    // rotate the messages
    const list = this.uploadingTarget.querySelector("ul")
    const item = list.querySelector("li")
    list.appendChild(item)

    // update again in a bit
    this.uploadingTimeout = setTimeout(this.updateUploadingMessage.bind(this), 10000)
  }

  stopUploadingMessages() {
    this.uploadingTarget.classList.add("hide")
    clearTimeout(this.uploadingTimeout)
  }
}
